import { AppSpecs, defaultAppSpecs } from '../experiments/appSpecs';

export type ExperimentsStoreState = Partial<AppSpecs>;

export class ExperimentsStore {
  private readonly specsWithDefaults: AppSpecs;

  constructor(private conductedSpecs: ExperimentsStoreState) {
    this.specsWithDefaults = { ...defaultAppSpecs, ...conductedSpecs };
  }

  public value<T extends keyof AppSpecs>(key: T): AppSpecs[T] {
    return this.specsWithDefaults[key];
  }

  public is<T extends keyof AppSpecs>(key: T, val: AppSpecs[T]): boolean {
    return this.specsWithDefaults[key] === val;
  }

  public css(): string {
    return Object.keys(this.specsWithDefaults)
      .filter((experimentKey: keyof AppSpecs) => this.is(experimentKey, 'true'))
      .join(' ');
  }

  public get enableTemplateVerticals() {
    return this.is('specs.marketing.EnableTemplateVerticals', 'true');
  }

  public get enableAppsInstaller() {
    return this.is('specs.marketing.EnableAppsInstaller', 'true');
  }

  public get enableZeroSearchAdiLinksInTemplatesGallery() {
    return this.is('specs.funnel.EnableZeroSearchAdiLinksInTemplatesGallery', 'true');
  }

  public get checkBlockerPopupOnEdit() {
    return this.is('specs.marketing.CheckBlockerPopupOnEdit', 'true');
  }

  public get templatesGalleryV2NumericPagination() {
    return this.is('specs.funnel.TemplatesGalleryV2NumericPagination', 'true');
  }

  public serialize(): ExperimentsStoreState {
    return this.conductedSpecs;
  }
}
